<template>
  <div id="app_dashboard_admin">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12">
          <v-card class="mx-auto custom_card_box_dashboard" elevation="0" border="sm opacity-1" rounded="md">
            <v-card flat class="pa-2">
              <template v-slot:title>
                <p class="ml-3 font-weight-bold custom_page_component_main_title">DEALER MAP</p>
                <div class="ml-3 mt-3">
                  <v-chip class="custom_blue_chip" label size="large" variant="outlined">
                    <div class="font-weight-bold text-body-1">{{ filteredDealerCount }}</div>
                  </v-chip>
                  <v-divider vertical></v-divider>
                  <v-chip class=" ml-3 custom_btn_secondary font-weight-bold" label size="large" variant="outlined">
                    DEALER COUNT
                  </v-chip>
                </div>
              </template>


              <template v-slot:append>

                <v-btn class="custom_pdf_btn ml-6 mr-4" variant="outlined" @click="exportPDF">
                  <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
                </v-btn>
              </template>
            </v-card>

            <v-divider></v-divider>

            <v-card-text>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" lg="3">
                  <v-autocomplete class="custom_input_field_color"
                                  v-model="dealerFilter.region"
                                  :items="regions"
                                  :loading="mRegionLoading"
                                  clearable
                                  label="Region"
                                  placeholder="Select region"
                                  variant="outlined"
                                  density="comfortable"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="3">
                  <v-autocomplete class="custom_input_field_color"
                                  v-model="dealerFilter.areaCode"
                                  :items="areaCodes"
                                  :loading="mAreaCodeLoading"
                                  :disabled="!dealerFilter.region"
                                  clearable
                                  label="Area Code"
                                  density="comfortable"
                                  placeholder="Select area code"
                                  variant="outlined"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="3">
                  <v-autocomplete class="custom_input_field_color"
                                  v-model="dealerFilter.company"
                                  :items="piyestraCompanies"
                                  clearable
                                  label="Company"
                                  placeholder="Select company"
                                  variant="outlined"
                                  density="comfortable"
                  ></v-autocomplete>
                </v-col>
                <!-- New Dealer Type Filter -->
                <v-col cols="12" xs="12" sm="12" md="6" lg="3">
                  <v-autocomplete class="custom_input_field_color"
                                  v-model="dealerFilter.dealerType"
                                  :items="dealerTypes"
                                  clearable
                                  label="Dealer Type"
                                  placeholder="Select dealer type"
                                  variant="outlined"
                                  density="comfortable"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row class="mb-2">
                <v-col cols="12" xs="12" sm="12" md="6" lg="4">
                  <v-text-field
                      id="radius_search_address"
                      v-model="searchAddress"
                      class="custom_input_field_color"
                      label="Search Address"
                      placeholder="Search an address on map"
                      density="comfortable"
                      variant="outlined"
                      append-inner-icon="mdi-magnify"
                      @keydown.enter.prevent="searchAddressByText"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="4">
                  <v-slider
                      v-model="radiusKm"
                      color="primary"
                      min="1"
                      max="25"
                      step="1"
                      thumb-label="always"
                      label="Radius (KM)"
                      hint="Please select a map location and set your desired radius before applying."
                      persistent-hint
                      @end="onRadiusCommitted"
                  ></v-slider>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="4" class="d-flex align-center justify-end ga-2">
                  <v-btn class="custom_btn_primary" :loading="radiusLoading" @click="openRadiusSearchDialog">
                    APPLY RADIUS
                  </v-btn>
                  <v-btn class="custom_btn_secondary" variant="outlined" @click="resetRadiusFilter">
                    RESET
                  </v-btn>
                </v-col>
              </v-row>

              <div class="map-container">
                <Map
                    ref="mapElement"
                    :center="mapCenter"
                    :zoom="8"
                    :options="mapOptions"
                    class="d-flex custom_map_div"
                >
                  <Marker
                      v-if="selectedPoint"
                      :position="selectedPoint"
                      :title="`Selected point (${selectedPoint.lat.toFixed(6)}, ${selectedPoint.lng.toFixed(6)})`"
                  ></Marker>

                  <!-- Markers -->
                  <Marker
                      v-for="dealer in filteredDealers"
                      :key="dealer.id"
                      :icon="{
          url: require('@/assets/ICONS/maker.png'),
          scaledSize: { width: 35, height: 38 },
        }"
                      :position="toMapPosition(dealer)"
                      :title="dealer.dealer_name"
                      @click="showDealerProfile(dealer)"
                  ></Marker>
                </Map>

                <!-- Details Panel -->
                <div v-if="selectedDealer" class="details-panel">
                  <div class="panel-header">
<!--                    <v-img width="40" height="40" class="rounded" :src="require('@/img/icons/total_sales_d.png')"></v-img>-->
                    <h3>{{ selectedDealer.dealer_name }}</h3>
                    <button @click="selectedDealer = null" class="close-btn">&times;</button>
                  </div>

                  <div class="panel-section">
                    <div class="section-title">
                      <span>Dealer Details</span>
                      <span class="reg-number">Dealer Code: {{ selectedDealer.dealer_code || '-' }}</span>
                    </div>

                    <div class="detail-row">
                      <span class="label">Dealer Name</span>
                      <span class="value">{{ selectedDealer.dealer_name }}</span>
                    </div>

                    <div class="detail-row">
                      <span class="label">Company Name</span>
                      <span class="value">{{ selectedDealer.company_name || '-' }}</span>
                    </div>

                    <div class="detail-row">
                      <span class="label">Mobile Number</span>
                      <span class="value">{{ selectedDealer.mobile_number || selectedDealer.mobile_number2 || '-' }}</span>
                    </div>

                    <div class="detail-row">
                      <span class="label">Company</span>
                      <span class="value">{{ selectedDealer.primary_company || selectedDealer.company_name || '-' }}</span>
                    </div>

                    <!-- Add Dealer Type to the details panel -->
                    <div class="detail-row" v-if="selectedDealer.dealer_type">
                      <span class="label">Dealer Type</span>
                      <span class="value">{{ selectedDealer.dealer_type }}</span>
                    </div>
                  </div>

                  <div class="address-section">
                    <h4>Address</h4>
                    <p>{{ selectedDealer.address || '-' }}</p>
                  </div>
                </div>
              </div>

              <v-dialog v-model="radiusConfirmDialog" max-width="500">
                <v-card>
                  <v-card-title class="text-h6">Search dealers in selected radius?</v-card-title>
                  <v-card-text>
                    <div class="mb-1"><strong>Radius:</strong> {{ radiusKm }} KM</div>
                    <div v-if="selectedPoint"><strong>Point:</strong> {{ selectedPoint.lat.toFixed(6) }}, {{ selectedPoint.lng.toFixed(6) }}</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn variant="text" @click="radiusConfirmDialog = false">Cancel</v-btn>
                    <v-btn color="primary" :loading="radiusLoading" @click="confirmRadiusSearch">Search</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {Map, Marker,} from '@fawmi/vue-google-maps';
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {mapGetters} from "vuex";

export default {
  components: {
    Map,
    Marker,
  },
  name: 'DealerMapDashboardComponentFour',

  data() {
    return {
      selectedDealer: null,
      showControls: true,
      mapOptions: {
        disableDefaultUI: false,
        zoomControl: true,
        mapTypeControl: true,
        fullscreenControl: true,
      },
      maxDate: new Date().toISOString().substr(0, 10), // Current date in 'YYYY-MM-DD' format
      regions: [],
      areaCodes: [],
      mRegionLoading: false,
      mAreaCodeLoading: false,
      piyestraCompanies: [
        'D.R.Home Appliances (Pvt) Ltd',
        'Piyestra Furniture (Pvt) Ltd',
        'D.R.Industries Electronics',
      ],
      // Updated Dealer Types based on the provided image
      dealerTypes: [
        'Furniture & Electronic',
        'Furniture',
        'Electronic',
        'Hardware',
        'Super Center-Daxer',
        'Book Shop',
        'Delivery & Government Suppliers',
        'Non Transaction'
      ],

      dealerFilter: {
        region: null,
        areaCode: null,
        company: null,
        dealerType: null,
      },

      mapCenter: {lat: 6.8738188, lng: 79.9931036}, // Default map center
      selectedPoint: null,
      radiusKm: 1,
      radiusLoading: false,
      searchAddress: '',
      radiusConfirmDialog: false,
      radiusRequestId: 0,
      activeRadiusRequestId: 0,
      dealers: [],
    }
  },

  created() {
    this.mapInstance = null;
    this.searchBoxInstance = null;
    this.radiusCircle = null;
    this.radiusCircles = [];
  },

  mounted() {
    this.fetchRegions();
    this.getDealerLocation();
    this.$nextTick(() => {
      this.$refs.mapElement?.$mapPromise
          .then((map) => {
            this.initRadiusMapFeatures(map);
          })
          .catch((error) => {
            console.error('Error initializing map features:', error);
          });
    });
  },

  beforeUnmount() {
    this.clearRadiusState({restoreDefaults: false});
  },

  computed: {

    filteredDealers() {
      const selectedRegion = this.normalizeValue(this.dealerFilter.region);
      const selectedAreaCode = this.normalizeValue(this.dealerFilter.areaCode);
      const selectedCompany = this.normalizeValue(this.dealerFilter.company);
      const selectedDealerType = this.normalizeValue(this.dealerFilter.dealerType);

      return this.dealers.filter((dealer) => {
        const dealerRegion = this.normalizeValue(
            dealer.region_code || dealer.regionCode || dealer.region || dealer.province
        );
        const dealerAreaCode = this.normalizeValue(
            dealer.area_code || dealer.areaCode
        );
        const dealerCompanies = this.getDealerCompanyValues(dealer);
        const dealerType = this.normalizeValue(dealer.dealer_type);

        return (
            (!selectedRegion || dealerRegion === selectedRegion) &&
            (!selectedAreaCode || dealerAreaCode === selectedAreaCode) &&
            (!selectedCompany || dealerCompanies.includes(selectedCompany)) &&
            (!selectedDealerType || dealerType === selectedDealerType)
        );
      });
    },

    filteredDealerCount() {
      return this.filteredDealers.length;
    },

    companyOptions() {
      const fromDealers = new Set();
      this.dealers.forEach((dealer) => {
        this.getDealerCompanyDisplayValues(dealer).forEach((company) => {
          fromDealers.add(company);
        });
      });

      const normalizedStatic = (this.piyestraCompanies || [])
          .map((company) => String(company).trim())
          .filter(Boolean);

      return Array.from(new Set([...normalizedStatic, ...fromDealers]));
    },

    ...mapGetters({dashboard: 'getDashboardDetails'})

  },

  methods: {

    normalizeValue(value) {
      if (value === null || value === undefined) {
        return '';
      }

      return String(value).trim().toLowerCase();
    },

    getDealerCompanyDisplayValues(dealer) {
      const companiesFromList = Array.isArray(dealer.companies)
          ? dealer.companies.map((company) => company?.company || company).filter(Boolean)
          : [];
      const fallbackCompanies = [
        dealer.ar_company,
        dealer.company,
        dealer.company_name,
        dealer.assign_company,
        dealer.piyestra_company,
      ].filter(Boolean);
      const companyField = Array.isArray(dealer.piyestra_companies)
          ? dealer.piyestra_companies
          : [];

      return [...companiesFromList, ...fallbackCompanies, ...companyField]
          .map((value) => String(value).trim())
          .filter(Boolean);
    },

    getDealerCompanyValues(dealer) {
      return this.getDealerCompanyDisplayValues(dealer)
          .map(this.normalizeValue)
          .filter(Boolean);
    },

    normalizeDealer(rawDealer) {
      const companies = Array.isArray(rawDealer?.companies)
          ? rawDealer.companies
          : [];
      const primaryCompany = companies[0]?.company || rawDealer?.company_name || rawDealer?.company || '';

      return {
        ...rawDealer,
        dealer_name: rawDealer?.dealer_name || rawDealer?.outlet_name || '',
        dealer_code: rawDealer?.dealer_code || rawDealer?.code || null,
        company_name: rawDealer?.company_name || rawDealer?.company || null,
        ar_company: rawDealer?.ar_company || null,
        address: rawDealer?.address || rawDealer?.outlet_address || null,
        latitude: rawDealer?.latitude ?? rawDealer?.lat,
        longitude: rawDealer?.longitude ?? rawDealer?.lng,
        region_code: rawDealer?.region_code || rawDealer?.regionCode || rawDealer?.region || null,
        area_code: rawDealer?.area_code || rawDealer?.areaCode || null,
        // Default to one of the new types if no type is provided
        dealer_type: rawDealer?.dealer_type || rawDealer?.dealerType || '01) Furniture & Electronic.',
        companies,
        primary_company: primaryCompany || rawDealer?.ar_company || null,
      };
    },

    normalizeDealerList(items) {
      return (items || [])
          .map((item) => this.normalizeDealer(item))
          .filter((dealer) => Number.isFinite(Number(dealer.latitude)) && Number.isFinite(Number(dealer.longitude)));
    },

    toMapPosition(dealer) {
      return {
        lat: Number(dealer.latitude),
        lng: Number(dealer.longitude),
      };
    },

    mapCodeList(items, keys) {
      return (items || [])
          .map((item) => {
            if (typeof item === 'string') {
              return item;
            }

            return keys.map((key) => item?.[key]).find(Boolean);
          })
          .filter(Boolean);
    },

    initRadiusMapFeatures(map) {
      this.mapInstance = map;

      map.addListener('click', (event) => {
        if (!event?.latLng) {
          return;
        }

        this.setSelectedPoint(event.latLng.lat(), event.latLng.lng(), {recenter: false});
        this.openRadiusSearchDialog();
      });

      this.initSearchBox(map);
    },

    initSearchBox(map) {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        console.warn('Google places library is not available; using manual search fallback.');
        return;
      }

      const input = document.getElementById('radius_search_address');
      if (!input) {
        return;
      }

      this.searchBoxInstance = new window.google.maps.places.SearchBox(input);
      map.addListener('bounds_changed', () => {
        this.searchBoxInstance.setBounds(map.getBounds());
      });

      this.searchBoxInstance.addListener('places_changed', () => {
        const places = this.searchBoxInstance.getPlaces();
        if (!places || places.length === 0) {
          return;
        }

        const place = places[0];
        if (!place.geometry || !place.geometry.location) {
          return;
        }

        this.searchAddress = place.formatted_address || place.name || this.searchAddress;
        this.setSelectedPoint(place.geometry.location.lat(), place.geometry.location.lng(), {recenter: true});
        this.openRadiusSearchDialog();
      });
    },

    searchAddressByText() {
      if (!this.searchAddress || !this.searchAddress.trim()) {
        return;
      }

      if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
        console.error('Google geocoder is not available.');
        return;
      }

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({address: this.searchAddress.trim()}, (results, status) => {
        if (status === 'OK' && results && results.length > 0 && results[0].geometry?.location) {
          const location = results[0].geometry.location;
          this.searchAddress = results[0].formatted_address || this.searchAddress;
          this.setSelectedPoint(location.lat(), location.lng(), {recenter: true});
          this.openRadiusSearchDialog();
          return;
        }

        console.error('Address search failed:', status);
      });
    },

    setSelectedPoint(lat, lng, {recenter = true} = {}) {
      this.selectedPoint = {lat: Number(lat), lng: Number(lng)};
      this.mapCenter = {...this.selectedPoint};
      this.updateRadiusCircle();

      if (recenter && this.mapInstance) {
        this.mapInstance.setCenter(this.selectedPoint);
      }
    },

    openRadiusSearchDialog() {
      if (!this.selectedPoint) {
        console.warn('Select a map point or address first.');
        return;
      }

      this.radiusConfirmDialog = true;
    },

    confirmRadiusSearch() {
      this.radiusConfirmDialog = false;
      this.fetchDealersWithinRadius();
    },

    clearRadiusCircle() {
      this.radiusCircles.forEach((circle) => {
        try {
          if (window.google?.maps?.event) {
            window.google.maps.event.clearInstanceListeners(circle);
          }
          circle.setMap(null);
        } catch (error) {
          console.warn('Error clearing radius circle:', error);
        }
      });

      this.radiusCircles = [];

      if (this.radiusCircle) {
        this.radiusCircle.setMap(null);
      }

      this.radiusCircle = null;
    },

    clearRadiusState({restoreDefaults = true} = {}) {
      this.radiusConfirmDialog = false;
      this.radiusLoading = false;
      this.selectedPoint = null;
      this.selectedDealer = null;
      this.searchAddress = '';

      if (restoreDefaults) {
        this.radiusKm = 1;
      }

      this.clearRadiusCircle();
    },

    updateRadiusCircle() {
      if (!this.mapInstance || !this.selectedPoint || !window.google || !window.google.maps) {
        this.clearRadiusCircle();
        return;
      }

      if (!this.radiusCircle) {
        this.radiusCircle = new window.google.maps.Circle({
          strokeColor: '#3f51b5',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#3f51b5',
          fillOpacity: 0.15,
          map: this.mapInstance,
        });

        this.radiusCircles.push(this.radiusCircle);
      }

      this.radiusCircle.setCenter(this.selectedPoint);
      this.radiusCircle.setRadius(Number(this.radiusKm) * 1000);
      this.radiusCircle.setMap(this.mapInstance);
    },

    onRadiusCommitted() {
      this.updateRadiusCircle();
    },

    fetchDealersWithinRadius() {
      if (!this.selectedPoint) {
        console.warn('Select a map point or address first.');
        return;
      }

      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      const requestId = ++this.radiusRequestId;
      this.activeRadiusRequestId = requestId;

      // Do not keep old markers while radius search is running.
      this.dealers = [];
      this.selectedDealer = null;
      this.radiusLoading = true;

      const selectedRegion = this.normalizeValue(this.dealerFilter.region);
      const selectedAreaCode = this.normalizeValue(this.dealerFilter.areaCode);
      const selectedCompany = this.normalizeValue(this.dealerFilter.company);
      const selectedDealerType = this.normalizeValue(this.dealerFilter.dealerType);
      
      const requestParams = {
        userId,
        latitude: this.selectedPoint.lat,
        longitude: this.selectedPoint.lng,
        radius_km: Number(this.radiusKm),
      };

      if (selectedRegion) {
        requestParams.region_code = this.dealerFilter.region;
      }
      if (selectedAreaCode) {
        requestParams.area_code = this.dealerFilter.areaCode;
      }
      if (selectedCompany) {
        requestParams.company = this.dealerFilter.company;
      }
      if (selectedDealerType) {
        requestParams.dealer_type = this.dealerFilter.dealerType;
      }

      axios
          .get('/api/dealers/map-Search', {
            params: requestParams,
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          })
          .then((response) => {
            if (requestId !== this.activeRadiusRequestId) {
              return;
            }

            if (response.status === 200) {
              this.dealers = this.normalizeDealerList(response.data?.data);
              if (this.dealers.length > 0) {
                this.setMapCenter();
              }
            } else {
              this.dealers = [];
              console.error('Error fetching dealers by radius:', response.data?.error);
            }
          })
          .catch((error) => {
            if (requestId !== this.activeRadiusRequestId) {
              return;
            }

            this.dealers = [];
            console.error('Error fetching dealers by radius:', error);
          })
          .finally(() => {
            if (requestId === this.activeRadiusRequestId) {
              this.radiusLoading = false;
            }
          });
    },

    resetRadiusFilter() {
      // Invalidate any in-flight radius request so stale responses cannot redraw old results.
      this.activeRadiusRequestId = ++this.radiusRequestId;
      this.clearRadiusState({restoreDefaults: true});

      this.getDealerLocation();
    },

    showDealerProfile(dealer) {
      this.selectedDealer = dealer
    },

    toggleControls() {
      this.showControls = !this.showControls;
      this.mapOptions = {
        disableDefaultUI: !this.showControls,
        zoomControl: this.showControls,
        mapTypeControl: this.showControls,
        fullscreenControl: this.showControls,
      };
    },

    handleDateChange(dateRange) {
      if (Array.isArray(dateRange) && dateRange.length === 2) {
        // Date range selected (start date and end date)
        const [startDate, endDate] = dateRange;
        this.fetchDealersByDateRange(startDate, endDate);
      } else if (dateRange) {
        // Single date selected
        this.fetchDealersByDateRange(dateRange, dateRange);
      }
      if (!dateRange) {
        this.getDealerLocation(); // Fetch all dealers again
      }

    },

    fetchDealersByDateRange(startDate, endDate) {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      const formData = new FormData();
      formData.append('userId', userId);
      formData.append('startDate', startDate);
      formData.append('endDate', endDate);

      // Log FormData content
      formData.forEach((value, key) => {
        console.log(`${key}: ${value}`);
      });

      console.log('Start Date:', new Date(startDate).toLocaleDateString());
      console.log('End Date:', new Date(endDate).toLocaleDateString());

      axios
          .post('/api/getOutletsByDateRange', formData, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.dealers = this.normalizeDealerList(response.data?.data);
              this.setMapCenter();
            } else {
              console.error('Error fetching dealers by date range:', response.data.error);
            }
          })
          .catch((error) => {
            console.error('Error fetching dealers by date range:', error);
          });
    },
    exportPDF() {
      // Hide controls before generating the PDF
      this.toggleControls(); // Hide the controls

      // Wait for the DOM to update before capturing the map
      setTimeout(() => {
        this.$nextTick(() => {
          const mapElement = this.$refs.mapElement?.$el || this.$refs.mapElement;

          if (mapElement instanceof HTMLElement) {
            html2canvas(mapElement, {
              useCORS: true, // Use CORS to allow cross-origin tiles to be captured
              logging: true,
              scale: 2, // Increase the scale to get better resolution
            })
                .then((canvas) => {
                  const imgData = canvas.toDataURL("image/png");
                  const pdf = new jsPDF({
                    orientation: "landscape", // Adjust this based on your map size
                    unit: "pt",
                    format: [canvas.width, canvas.height], // Use the exact size of the canvas for PDF format
                  });

                  // Add the captured image to the PDF
                  pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);

                  // Save the PDF
                  pdf.save("dealer_map.pdf");
                  const fileName = 'dealer_map.pdf';
                  this.logDocumentDownload(fileName);
                })
                .catch((error) => {
                  console.error("Error capturing the map:", error);
                })
                .finally(() => {
                  // Restore controls after generating the PDF
                  this.toggleControls(); // Show the controls
                });
          } else {
            console.error("Map element is not attached or is not a valid node.");
            // Restore controls if the map element is invalid
            this.toggleControls();
          }
        });
      }, 200); // Add a 300ms delay to ensure the controls are hidden
    },

    async logDocumentDownload(fileName) {
      console.log(fileName);
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!userId) {
          throw new Error('User ID not found');
        }

        // Asynchronous API call to log download
        const response = await axios.post(`/api/log-document-download`, {
          user_id: userId,
          file_type: 'pdf',
          file_name: fileName,
          entity_area: 'Dashboard',

          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status !== 200) {
          throw new Error('Failed to log download');
        }

        console.log('Download logged successfully');
      } catch (error) {
        console.error('Error logging download:', error);
      }
    },

    fetchRegions() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      if (!userId) {
        this.regions = [];
        return;
      }

      this.mRegionLoading = true;
      axios
          .get(`/api/region-code-list?userId=${encodeURIComponent(userId)}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.regions = this.mapCodeList(response.data?.data, ['region_code', 'regionCode', 'region', 'code', 'value']);
            } else {
              this.regions = [];
            }
          })
          .catch((error) => {
            this.regions = [];
            console.error('Error fetching regions:', error);
          })
          .finally(() => {
            this.mRegionLoading = false;
          });
    },

    fetchAreaCodesByRegion(regionCode) {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      if (!userId || !regionCode) {
        this.areaCodes = [];
        return;
      }

      this.mAreaCodeLoading = true;
      axios
          .get(`/api/area-code-by-region?userId=${encodeURIComponent(userId)}&region_code=${encodeURIComponent(regionCode)}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.areaCodes = this.mapCodeList(response.data?.data, ['area_code', 'areaCode', 'code', 'value']);
            } else {
              this.areaCodes = [];
            }
          })
          .catch((error) => {
            this.areaCodes = [];
            console.error('Error fetching area codes:', error);
          })
          .finally(() => {
            this.mAreaCodeLoading = false;
          });
    },


    getDealerLocation() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      axios.get('/api/getAllDealers', {
        params: {
          userId,
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
          .then(response => {
            if (response.status === 200) {
              this.dealers = this.normalizeDealerList(response.data?.data);
              this.setMapCenter();
              console.log('data', this.dealers);
            } else {
              console.error("Error:", response.data.error);
            }
          })
          .catch(error => {
            console.error("Error fetching chart details:", error);
          });
    },
    setMapCenter() {
      if (this.dealers.length > 0) {
        const firstDealer = this.dealers[0];
        const lat = Number(firstDealer.latitude);
        const lng = Number(firstDealer.longitude);
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          this.mapCenter = {lat, lng};
        }
      }
    },
  },

  mutations: {
    updateDashboardTotalOutlet(state, count) {
      state.dashboard.totalOutlet = count;
    },
  },


  watch: {
    filteredDealerCount(newCount) {
      this.$store.commit('updateDashboardTotalOutlet', newCount);
    },

    "dealerFilter.region"(newValue) {
      this.dealerFilter.areaCode = null;
      this.areaCodes = [];

      if (newValue) {
        this.fetchAreaCodesByRegion(newValue);
      }
    },

    radiusKm() {
      this.updateRadiusCircle();
    },
  },

};
</script>

<style>
@import "../../styles/dashboard/dashboard.scss";
</style>



<style scoped>
.map-container {
  position: relative;
}

.details-panel {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 320px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  z-index: 1000;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #3f51b5;
  color: white;
  border-radius: 8px 8px 0 0;
}

.panel-header h3 {
  margin: 0;
  font-size: 1.2rem;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0 5px;
}

.panel-section {
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.section-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  font-weight: bold;
}

.reg-number {
  color: #666;
  font-size: 0.9em;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  padding: 5px 0;
}

.label {
  color: #666;
  width: 45%;
}

.value {
  width: 50%;
  font-weight: 500;
}

.address-section {
  padding: 15px;
}

.address-section h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 1rem;
}

.address-section p {
  margin: 0;
  color: #666;
  line-height: 1.4;
}
</style>